export default __webpack_public_path__ + "static/media/calender.def64aa1.svg";